import { Button, Stack, TextField, Typography } from "@mui/material";
import { Dialog } from "components/Dialog";
import { useState } from "react";

interface Props {
  open: boolean;
  facilityName: string | null;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

/**
 * Collects the required free-text reason before ignoring a CERS facility.
 * The Ignore button is disabled until the trimmed reason is non-empty (the
 * server also rejects a blank reason).
 */
export function IgnoreReasonDialog({ open, facilityName, loading, onConfirm, onClose }: Props) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      title="Ignore CERS facility"
      noPrimaryAction
      hideCancelButton
    >
      <Stack spacing={2} sx={{ pb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Mark <strong>{facilityName ?? "this facility"}</strong> as not under Encamp contract. Its
          rejections drop out of the tracker by default.
        </Typography>
        <TextField
          label="Reason"
          required
          multiline
          minRows={2}
          fullWidth
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Why is this facility being ignored?"
        />
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="staff"
            disabled={loading || trimmed.length === 0}
            onClick={() => onConfirm(trimmed)}
          >
            {loading ? "Ignoring…" : "Ignore"}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
